import styled, { css } from 'styled-components';
import { Button } from '../Button';
import { ICON_CLASS } from '../Icons/tokens';
import { getFontSizeWithStrokeWidth, getInterFontWeightCSS, negateVariable, theme } from '../theme';
import { tokens } from './tokens';
import { AvatarIndicatorVariant } from './types';
const baseAvatarStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: ${tokens.radius};
`;
// Styled AvatarIndicator components _________________________________________________________
export const StyledIndicatorStatus = styled.span``;
export const StyledIndicatorCustom = styled.span``;
export const StyledIndicatorWrapper = styled.span`
  outline: ${tokens.AvatarIndicator.outlineBorder.width} solid ${tokens.AvatarIndicator.outlineBorder.color};
  overflow: hidden;

  &,
  ${StyledIndicatorStatus}, ${StyledIndicatorCustom} {
    ${baseAvatarStyle}
    width: ${({ $size, $variant })=>tokens.AvatarIndicator[$variant].sizes[$size].dimension};
    height: ${({ $size, $variant })=>tokens.AvatarIndicator[$variant].sizes[$size].dimension};
    background: ${({ $status, $variant })=>$variant === AvatarIndicatorVariant.status ? tokens.AvatarIndicator.status[$status].color : tokens.AvatarIndicator.custom.background};
  }
`;
// Styled Avatar components _________________________________________________________
export const Root = styled.div`
  ${baseAvatarStyle}
  background: ${tokens.background};
  color: ${tokens.text.color};
  ${getInterFontWeightCSS(tokens.text.weight)};
  ${({ size })=>css`
    height: ${tokens.sizes[size].dimension};
    width: ${tokens.sizes[size].dimension};
  `}
  ${({ withBorder })=>withBorder ? `
  border: 1px solid ${theme.colors.gray300};
  ` : ''}
`;
export const Text = styled.span`
  ${({ size })=>css`
    font-size: ${tokens.sizes[size].text.fontSize};
    line-height: ${tokens.sizes[size].text.lineHeight};
  `}
`;
export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: ${tokens.radius};
  overflow: hidden;
  display: ${({ $visible })=>$visible ? 'block' : 'none'};
`;
export const StyledAvatarImageWrapper = styled.div`
  ${baseAvatarStyle}
  background: ${tokens.background};
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 8%);
  ${({ $size })=>css`
    height: ${tokens.sizes[$size].dimension};
    width: ${tokens.sizes[$size].dimension};
  `}
`;
export const StyledDefaultIcon = styled.div`
  ${baseAvatarStyle}
  width: 100%;
  height: 100%;
  overflow: hidden;

  .${ICON_CLASS} {
    width: ${({ $size })=>tokens.sizes[$size].icon.dimension};
    height: ${({ $size })=>tokens.sizes[$size].icon.dimension};
  }
`;
export const StyledAvatar = styled.div`
  ${baseAvatarStyle}
  position: relative;
  outline: 1px solid rgba(0, 0, 0, 8%);
  outline-offset: -1px;

  /* Indicator positioning: custom variant has negative offset, status variant at corner */
  ${StyledIndicatorWrapper} {
    position: absolute;
    ${({ $variant })=>$variant === AvatarIndicatorVariant.custom ? css`
            bottom: ${negateVariable(theme.spaces.x2)};
            right: ${negateVariable(theme.spaces.x2)};
          ` : css`
            bottom: 0;
            right: 0;
          `}
  }
`;
export const StyledAddButton = styled(Button)`
  flex-shrink: 0;
  border-radius: ${tokens.radius};
  padding: ${theme.spaces.x4};
  width: ${({ size })=>tokens.sizes[size].dimension};
  height: ${({ size })=>tokens.sizes[size].dimension};
  ${getInterFontWeightCSS(tokens.text.weight)};

  &,
  &:hover,
  &:focus,
  &:hover:focus,
  &:active {
    border: 1px dashed ${theme.colors.gray300};
    background: ${({ $disabled })=>$disabled ? theme.colors.gray50 : theme.colors.white};
    color: ${({ $disabled })=>$disabled ? theme.colors.gray300 : theme.colors.gray400};
  }

  ${({ $disabled })=>$disabled ? css`
          background: ${theme.colors.gray50};
          cursor: not-allowed;
        ` : css`
          &:hover {
            background: ${theme.colors.gray50};
            color: ${theme.colors.gray500};
          }
        `}

  ${ICON_CLASS} {
    ${getFontSizeWithStrokeWidth(tokens.sizes.m.text.fontSize)}
  }
`;
